import React from 'react';

const SHORTCUTS = {
  'Drawing Tools': [
    ['1', 'Conduit tool'],
    ['2', 'Fiber tool'],
    ['3', 'Measure tool'],
    ['4-9', 'Device tools (HH, FP, 1x4, 1x8, Splice, Slack)'],
    ['0', 'Ground Rod tool'],
    ['Dbl-click', 'Finish current line'],
    ['Right-click', 'Remove last point'],
    ['Esc', 'Cancel drawing / Deselect'],
  ],
  'Editing': [
    ['Del / Backspace', 'Delete selected item'],
    ['Ctrl+Z', 'Undo'],
    ['Ctrl+Y', 'Redo'],
    ['Ctrl+C', 'Copy selected'],
    ['Ctrl+V', 'Paste'],
    ['Ctrl+D', 'Duplicate selected'],
    ['J', 'Merge/Join selected segments'],
    ['X', 'Split segment at nearest point'],
  ],
  'Navigation': [
    ['S', 'Toggle snap-to-device'],
    ['L', 'Toggle legend'],
    ['G', 'Toggle grid overlay'],
    ['Shift+Drag', 'Lasso select'],
  ],
  'View': [
    ['C', 'Toggle conduit labels'],
    ['F', 'Toggle fiber labels'],
    ['D', 'Toggle device labels'],
    ['T', 'Toggle map type (Road/Satellite)'],
    ['N', 'Toggle dark mode'],
    ['B', 'Toggle billing summary'],
  ],
  'File': [
    ['Ctrl+S', 'Force save'],
    ['Ctrl+P', 'Publish to live map'],
    ['Ctrl+E', 'Export JSON'],
    ['Ctrl+I', 'Import JSON'],
  ],
};

export default function KeyboardShortcutsModal({ onClose, darkMode }) {
  const bg = darkMode ? '#1a1a2e' : '#ffffff';
  const text = darkMode ? '#e0e0e0' : '#333';
  const border = darkMode ? '#333' : '#ddd';
  const keyBg = darkMode ? '#0f3460' : '#f0f0f0';

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'rgba(0,0,0,0.5)', zIndex: 2000,
    }} onClick={onClose}>
      <div style={{
        width: 580, maxHeight: '80vh', background: bg, borderRadius: 10,
        boxShadow: '0 8px 32px rgba(0,0,0,0.4)', overflow: 'hidden',
        display: 'flex', flexDirection: 'column',
      }} onClick={e => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px 18px', borderBottom: `1px solid ${border}` }}>
          <span style={{ fontWeight: 700, color: text, fontSize: 16 }}>Keyboard Shortcuts</span>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: text, cursor: 'pointer', fontSize: 20 }}>×</button>
        </div>
        <div style={{ overflowY: 'auto', padding: '10px 18px 18px' }}>
          {Object.entries(SHORTCUTS).map(([category, shortcuts]) => (
            <div key={category} style={{ marginBottom: 16 }}>
              <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', color: '#c850c0', marginBottom: 6, letterSpacing: 1 }}>{category}</div>
              {shortcuts.map(([key, desc], i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', padding: '4px 0', gap: 12 }}>
                  <kbd style={{
                    minWidth: 80, padding: '3px 8px', borderRadius: 4, fontSize: 11,
                    background: keyBg, border: `1px solid ${border}`, color: text,
                    fontFamily: 'monospace', textAlign: 'center', fontWeight: 600,
                  }}>{key}</kbd>
                  <span style={{ fontSize: 12, color: text, opacity: 0.85 }}>{desc}</span>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
